import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import {
  Header,
  Statistic,
  Segment,
  List,
  Message,
  Icon,
} from 'semantic-ui-react'
import moment from 'moment-timezone'
import DataContext from '../../contexts/DataContext'

const PaymentHistory = () => {
  const { advisor, balance } = useContext(DataContext)

  const jobs = advisor.jobs.filter((j) => j.bonuses.length > 0 || j.payment)

  const getJobTransactions = (job) => {
    const txs = []
    if (job.payment) txs.push(job.payment)
    if (job.bonuses.length) txs.push(...job.bonuses)
    return txs
  }

  const sortJobTransactions = (job) => {
    return getJobTransactions(job).sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    )
  }

  // Sort jobs by latest transaction
  jobs.sort((a, b) => {
    const aTxs = sortJobTransactions(a)
    const bTxs = sortJobTransactions(b)

    const aLatest = aTxs.length > 0 ? new Date(aTxs[0].createdAt) : 0
    const bLatest = bTxs.length > 0 ? new Date(bTxs[0].createdAt) : 0

    return bLatest - aLatest
  })

  const renderPaymentHistory = () => {
    if (jobs.length === 0) {
      return 'No Payment Data'
    }
    return (
      <List className="projects">
        {jobs.map((job) => {
          const txs = sortJobTransactions(job)
          const total = txs
            .map((t) => t.amount)
            .reduce((sum, amount) => sum + amount, 0)
            .toFixed(2)
          return (
            <List.Item key={job.id} className="project">
              <List.Header>{job.project.title}</List.Header>
              {`Total $${total} Earned`}
              <List bulleted>
                {txs.map((t) => (
                  <List.Item key={t.createdAt}>
                    {`$${t.amount} paid via ${t.method} | ${
                      moment(t.createdAt).tz(advisor.timeZone)?.format('LL') ||
                      ''
                    }`}
                  </List.Item>
                ))}
              </List>
            </List.Item>
          )
        })}
      </List>
    )
  }

  return (
    <div id="payment-history">
      <Header as="h1" className="title">
        Payment History
      </Header>
      <Statistic.Group size="small" widths={2}>
        <Statistic>
          <Statistic.Value>${balance}</Statistic.Value>
          <Statistic.Label>Total earned</Statistic.Label>
        </Statistic>
        <Statistic>
          <Statistic.Value>{jobs.length}</Statistic.Value>
          <Statistic.Label>Number of Projects</Statistic.Label>
        </Statistic>
      </Statistic.Group>
      <Segment className="transactions">{renderPaymentHistory()}</Segment>
      <Message icon>
        <Icon name="lightbulb" />
        <Message.Content>
          <span style={{ fontWeight: '900' }}>Tip</span>: You can receive more
          project opportunities by adding more tags to your{' '}
          <Link to="/profile" className="profile-link">
            profile
          </Link>
        </Message.Content>
      </Message>
    </div>
  )
}

export default PaymentHistory
